<script lang="ts">
	import Input from '$lib/components/Global/Fields/Input.svelte';
	import { type ComponentProps } from 'svelte';
	import { type StepUpdater } from '../../Stepper/stepper';
	import FieldWrapper from './FieldWrapper.svelte';

	export let name: string;
	export let onUpdate: StepUpdater<string> | null = null;

	interface $$Props extends ComponentProps<Input> {
		name: string;
		onUpdate?: StepUpdater<string> | null;
	}

	let value: string = '';
</script>

<FieldWrapper
	{name}
	{onUpdate}
	let:handleUpdate
	let:error
	on:value={(e) => {
		value = e.detail || '';
	}}
>
	<Input {name} {value} {error} {...$$restProps} on:input={handleUpdate}>
		<slot slot="after" name="after" />
	</Input>
</FieldWrapper>
